import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class AlertService {
  constructor(private toastr: ToastrService) { }

  success(mensaje: string) {
    this.toastr.success(
      `<span class="toast-icon"><i class="bi bi-exclamation-circle" style="color:#28a745"></i></span> ${mensaje}`,
      '',
      { enableHtml: true }
    );
  }

  warning(mensaje: string) {
    this.toastr.warning(
      `<span class="toast-icon"><i class="bi bi-exclamation-circle" style="color:#ffc107"></i></span> ${mensaje}`,
      '',
      { enableHtml: true }
    );
  }

  error(mensaje: string) {
    this.toastr.error(
      `<span class="toast-icon"><i class="bi bi-exclamation-circle" style="color:#dc3545"></i></span> ${mensaje}`,
      '',
      { enableHtml: true }
    );
  }
}